<nz-tabset
  [nzSelectedIndex]="activeTabIndex"
  (nzSelectedIndexChange)="onTabIndexChange($event)"
>
  <nz-tab
    [nzTitle]="'USER_REQUESTS.AI_TRANSLATION.TAB' | translate"
    [nzDisabled]="aiTabDisabled"
  >
    <app-lot-ai-translation-tab
      [canRequest]="canRequestAiTranslation"
      [languages]="aiLanguages"
      [language]="aiLanguage"
      (languageChange)="aiLanguage = $event"
    ></app-lot-ai-translation-tab>
  </nz-tab>

  <nz-tab
    [nzTitle]="manualTabTooltip ? manualTabTitleWithTooltipTpl : manualTabTitlePlainTpl"
    [nzDisabled]="manualTabDisabled"
  >
    <app-lot-manual-translation-tab
      [currentUser]="currentUser"
      [translationState]="translationState"
      [disabled]="manualTabDisabled"
      (manualTabDataPayloadChange)="manualTabPayload = $event"
    ></app-lot-manual-translation-tab>
  </nz-tab>

  <ng-template #manualTabTitlePlainTpl>
    <span>
      {{ 'USER_REQUESTS.MANUAL_TRANSLATION.TAB' | translate }}
    </span>
  </ng-template>

  <ng-template #manualTabTitleWithTooltipTpl>
    <span
      nz-tooltip
      [nzTooltipTitle]="'USER_REQUESTS.MANUAL_TRANSLATION.AI_REQUIRED_TOOLTIP' | translate"
      [nzTooltipTrigger]="'hover'"
    >
      {{ 'USER_REQUESTS.MANUAL_TRANSLATION.TAB' | translate }}
    </span>
  </ng-template>
</nz-tabset>

<ng-container *nzModalFooter>
  <button nz-button nzType="default" (click)="destroyModal()">
    {{ 'CANCEL' | translate }}
  </button>

  <button
    nz-button
    nzType="primary"
    [disabled]="(creating$ | async) || submitDisabled"
    [nzLoading]="creating$ | async"
    (click)="submitActiveTab()"
  >
    {{
      (isAiTabActive
        ? 'USER_REQUESTS.AI_TRANSLATION.CREATE_TRANSLATION'
        : 'USER_REQUESTS.CREATE') | translate
    }}
  </button>
</ng-container>
